<div class="container-fuid w-100 sub-header d-flex align-items-center">
  <div class="w-100 ms-2 ms-sm-2 ms-md-2 ms-lg-5 ms-xl-5 ms-xxl-5 me-2 me-sm-2 me-md-2 me-lg-5 me-xl-5 me-xxl-5">
    <nav aria-label="breadcrumb" class="align-items-center p-2">
      <ol class="breadcrumb fw-normal">
        @for (breadCrumb of breadCrumbs; track breadCrumb; let isLastBreadCrumb = $last) {
          <li class="breadcrumb-item">
            @if (isLastBreadCrumb) {
              <label translate="SettingsBreadCrumb.{{breadCrumb.translationKey}}"></label>
            }
            @if (!isLastBreadCrumb) {
              @if (breadCrumb.displayTitle) {
                <a [routerLink]="breadCrumb.redirectRoute">{{breadCrumb.displayTitle}}
                </a>
              }
              @if (!breadCrumb.displayTitle) {
                <a [routerLink]="breadCrumb.redirectRoute"
                  translate="SettingsBreadCrumb.{{breadCrumb.translationKey}}">
                </a>
              }
            }
          </li>
        }

        <!-- NO BREADCRUMBS SUPPLIED - DEFAULT TO BUILDER STANDARD-->
        @if (!breadCrumbs) {
          <!-- MAIN DASHBOARD -->
          <li class="breadcrumb-item"><a routerLink="/dashboard" translate="dashboard.title"></a></li>
          <!-- secondary if given, else default to a 'General request'-->
          @if (secondCrumb) {
            <li class="breadcrumb-item text-truncate" aria-current="page">{{secondCrumb}}</li>
          }
          @if (!secondCrumb) {
            <li class="breadcrumb-item text-truncate" aria-current="page" translate="Request.Header.GeneralRequest">
            </li>
          }
        }

      </ol>
    </nav>
  </div>
</div>